/*
 * Stoff und Stahl — Intro-Video im Startbereich, dazu die Bewegung beim Scrollen.
 *
 * Ob das Intro ueberhaupt laeuft, hat schon das kleine Skript im Abschnitt
 * entschieden (Klasse sus-start--intro). Hier geht es nur noch darum, es
 * sauber durchzufuehren:
 *
 *   - Quelle erst jetzt setzen, damit die 1,2 MB nur geladen werden, wenn sie
 *     auch gebraucht werden.
 *   - Einblenden erst bei "playing". Vorher sieht man das Standbild, also das
 *     erste Videobild - der Wechsel darauf faellt nicht auf.
 *   - Kommt binnen 1 s kein "playing" (blockiertes Autoplay, Datensparmodus),
 *     wird in 0,4 s auf das Startfoto geblendet und das Video verworfen.
 *     Es gibt nie einen Play-Knopf.
 *   - Am Ende ohne Uebergang auf das Startfoto, dann der Claim.
 *   - Antippen springt sofort zum Endzustand.
 */
(() => {
  const start = document.querySelector('[data-sus-start]');
  if (!start) return;

  const video = start.querySelector('.sus-start__video');
  const intro = start.classList.contains('sus-start--intro');
  let beendet = false;

  // Das Endfoto haengt an data-Attributen (siehe Abschnitt im Liquid). Es wird
  // erst freigeschaltet, wenn das Standbild da ist — sonst nehmen sich beide
  // gegenseitig die Bandbreite und das LCP-Element kommt zu spaet.
  const fotoBild = start.querySelector('.sus-start__foto');
  const fotoLaden = () => {
    const kasten = fotoBild && fotoBild.parentElement;
    if (!kasten) return;
    kasten.querySelectorAll('source[data-srcset]').forEach((q) => {
      q.setAttribute('srcset', q.dataset.srcset);
      q.removeAttribute('data-srcset');
    });
    if (fotoBild.dataset.src) {
      fotoBild.setAttribute('src', fotoBild.dataset.src);
      delete fotoBild.dataset.src;
    }
  };

  const umschalten = (weich) => {
    start.classList.toggle('sus-start--weich', !!weich);
    start.classList.remove('sus-start--intro', 'sus-start--laeuft');
    start.classList.add('sus-start--fertig');
    if (video) {
      try { video.pause(); } catch (e) {}
      video.removeAttribute('src');
      try { video.load(); } catch (e) {}
    }
  };

  const fertig = (weich) => {
    if (beendet) return;
    beendet = true;
    clearTimeout(wecker);
    fotoLaden();
    // Erst umschalten, wenn das Foto wirklich da ist. Bis dahin bleibt das
    // Standbild stehen (es liegt darunter) — sonst blendet der Wechsel auf
    // ein leeres Bild und das Foto blitzt danach nach.
    if (fotoBild && !fotoBild.complete) {
      let getan = false;
      const los = () => { if (getan) return; getan = true; umschalten(weich); };
      fotoBild.addEventListener('load', los, { once: true });
      fotoBild.addEventListener('error', los, { once: true });
      setTimeout(los, 2000);
    } else {
      umschalten(weich);
    }
  };

  let wecker = 0;
  if (intro && video) {
    video.addEventListener('playing', () => {
      clearTimeout(wecker);
      start.classList.add('sus-start--laeuft');
    }, { once: true });

    video.addEventListener('ended', () => fertig(false), { once: true });
    video.addEventListener('error', () => fertig(true), { once: true });
    video.addEventListener('stalled', () => fertig(true), { once: true });

    start.addEventListener('pointerdown', () => fertig(false), { once: true });

    const quelle = start.dataset.video;
    if (!quelle) {
      fertig(true);
    } else {
      // Das Standbild ist das LCP-Element. Das Video darf erst danach Bandbreite
      // nehmen, sonst holt der Browser beides gleichzeitig und das Bild kommt
      // spaeter: am 16.10.2026 auf dem Handy gemessen 3200 ms statt 1778 ms.
      // Im Testtheme war das nicht zu sehen, weil die Vorschau ihre HTML
      // langsamer liefert und das Bild dadurch von sich aus Vorsprung hatte.
      let angelaufen = false;
      const starten = () => {
        if (angelaufen || beendet) return;
        angelaufen = true;
        // Erst hier beginnt die Frist: blockiert der Browser das Abspielen,
        // darf der Besucher davon nichts merken.
        wecker = setTimeout(() => fertig(true), 1000);
        fotoLaden();
        video.src = quelle;
        const versuch = video.play();
        if (versuch && typeof versuch.catch === 'function') versuch.catch(() => fertig(true));
      };

      // Abgefragt statt am load-Ereignis: Das Ereignis war am 16.10.2026 nicht
      // zu fassen — das Bild stand geladen da, die Notbremse nach 3 s hat das
      // Intro gestartet. Eine Abfrage alle 50 ms kann nichts verpassen.
      const standbild = start.querySelector('.sus-start__erst');
      const frist = performance.now() + 3000;
      const warten = () => {
        if (!standbild || standbild.complete || performance.now() > frist) starten();
        else setTimeout(warten, 50);
      };
      warten();
    }
  }

  /* --- Bewegung beim Scrollen: Claim nach oben, Bild etwas langsamer ------ */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const text = start.querySelector('.sus-start__text');
  const bild = start.querySelector('.sus-start__bild');
  if (!text || !bild) return;
  const schmal = window.matchMedia('(max-width: 768px)');
  let laeuft = false;

  const zeichnen = () => {
    laeuft = false;
    if (!schmal.matches) {
      text.style.transform = '';
      bild.style.transform = '';
      return;
    }
    const hoehe = start.offsetHeight || 1;
    const anteil = Math.min(1, Math.max(0, window.scrollY / hoehe));
    text.style.transformOrigin = 'left top';
    text.style.transform = `translate3d(0, ${(-anteil * 60).toFixed(1)}px, 0) scale(${(1 - anteil * 0.18).toFixed(3)})`;
    bild.style.transform = `translate3d(0, ${(anteil * 24).toFixed(1)}px, 0)`;
  };

  const anstossen = () => {
    if (laeuft) return;
    laeuft = true;
    requestAnimationFrame(zeichnen);
  };
  window.addEventListener('scroll', anstossen, { passive: true });
  window.addEventListener('resize', anstossen, { passive: true });
})();
